import { FC } from 'react';
import { cn } from '@utils/cn';

interface TrialCountdownPillProps {
  /** Whole days left in the trial. Zero renders as "Ends today". */
  daysRemaining: number;
  /** Highlight the final stretch. Callers pass this from useTrialStatus thresholds. */
  urgent?: boolean;
  className?: string;
}

/**
 * Compact "N days left" badge for the sidebar.
 *
 * An atom, not a molecule: it holds no state and fetches nothing — the caller supplies the
 * number. Colors sit against the indigo sidebar card rather than the page background.
 */
export const TrialCountdownPill: FC<TrialCountdownPillProps> = ({
  daysRemaining,
  urgent = false,
  className,
}) => {
  const label =
    daysRemaining <= 0
      ? 'Trial ends today'
      : daysRemaining === 1
        ? '1 day left in trial'
        : `${daysRemaining} days left in trial`;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        urgent
          ? 'bg-amber-400 text-amber-950'
          : 'bg-indigo-500/40 text-indigo-50',
        className,
      )}
      title={label}>
      {label}
    </span>
  );
};

export default TrialCountdownPill;
